import React from "react";
import {
    Dialog,
    Spinner,
    Label,
    Input,
    DialogSurface,
    DialogTitle,
    DialogContent,
    DialogBody,
    DialogActions,
    Button,
} from "@fluentui/react-components";
import { useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth, Base_Url } from "../../services/firebase";
import UserDataService from "../../services/userDataService";
import ServiceProviderDataService from "../../services/ServiceProviderDataService";

function UpdateEmailDialogBox({
    isOpen,
    setIsOpen,
    userId,
    currentEmail,
    onUpdateSuccess
}) {
    const [loading, setLoading] = useState(false);
    const [user] = useAuthState(auth);
    const [newEmail, setNewEmail] = useState("");
    const [error, setError] = useState("");

    const handleUpdate = async () => {
        setError("");
        if (!newEmail) {
            setError("Please enter a new email address.");
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(newEmail)) {
            setError("Please enter a valid email address.");
            return;
        }

        if (newEmail.toLowerCase() === currentEmail.toLowerCase()) {
            setError("New email must be different from the current email.");
            return;
        }

        setLoading(true);
        try {
            if (!user) {
                setError("User not authenticated.");
                setLoading(false);
                return;
            }

            const token = await user.getIdToken();

            const response = await fetch(`${Base_Url}/updateUserEmail`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                    "Accept": "application/json",
                },
                body: JSON.stringify({
                    uid: userId,
                    newEmail: newEmail.toLowerCase(),
                }),
            });

            if (!response.ok) {
                const errText = await response.text().catch(() => "");
                console.error("API error:", response.status, errText);
                setError(`API error: ${response.status} ${errText}`);
                setLoading(false);
                return;
            }

            await UserDataService.updateUserField(userId, { email: newEmail.toLowerCase() });

            try {
                const serviceProviderDoc = await ServiceProviderDataService.getServiceProvider(userId);
                if (serviceProviderDoc.exists()) {
                    await ServiceProviderDataService.updateServiceProvider(userId, { email: newEmail.toLowerCase() });
                }
            } catch (spError) {
                console.warn("ServiceProvider not found or error updating:", spError);
            }

            setIsOpen(false);
            alert("Email updated successfully.");
            if (onUpdateSuccess) {
                onUpdateSuccess();
            }
        } catch (error) {
            console.error("Error updating email:", error);
            setError("Failed to update email.");
            alert("Failed to update email.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog
            open={isOpen}
            onOpenChange={(e, data) => setIsOpen(data.open)}
        >
            <DialogSurface>
                <DialogBody>
                    <DialogTitle>Update Email</DialogTitle>
                    <DialogContent>
                        <div style={{ marginBottom: "12px" }}>
                            <Label className={"side-drawer-field__label"} style={{ marginLeft: "4px" }}>Current Email</Label>
                            <Input
                                value={currentEmail}
                                disabled
                                className={"side-drawer-field side-drawer-field__gap"}
                                style={{ width: "100%" }}
                            />
                        </div>

                        <div style={{ marginBottom: "8px" }}>
                            <Label className={"side-drawer-field__label"} style={{ marginLeft: "4px" }}>New Email Address</Label>
                        </div>
                        <Input
                            placeholder={"Enter New Email"}
                            className={"side-drawer-field  side-drawer-field__gap"}
                            value={newEmail}
                            onChange={(ev) => setNewEmail(ev.target.value)}
                            type="email"
                            style={{ width: "100%" }}
                        />
                        {error && <div style={{ color: "red", marginTop: "8px", fontSize: "12px" }}>{error}</div>}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            appearance="primary"
                            onClick={handleUpdate}
                            style={{
                                backgroundColor: "#E97451",
                                color: "black",
                                whiteSpace: "nowrap",
                                position: "relative",
                            }}
                            disabled={loading || !newEmail}
                        >
                            {loading ? <Spinner size="tiny" /> : "Update"}
                        </Button>
                        <Button appearance="secondary" onClick={() => setIsOpen(false)}>
                            Cancel
                        </Button>
                    </DialogActions>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    );
}

export default UpdateEmailDialogBox;
